import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import type { SxProps, Theme } from "@mui/material/styles";

import type { SearchResultItem } from "@/services/search";

interface Props {
    item: SearchResultItem;
    onClick: (item: SearchResultItem) => void;
    primaryWeight?: number | "";
    secondary?: React.ReactNode;
    sx?: SxProps<Theme>;
}

export default function SearchListItem({
    item,
    onClick,
    primaryWeight = 400,
    secondary,
    sx,
}: Props) {
    return (
        <ListItem disablePadding sx={sx}>
            <ListItemButton onClick={() => onClick(item)} sx={{ py: 0.5 }}>
                <ListItemText
                    primary={item.label}
                    secondary={secondary}
                    slotProps={{
                        primary: {
                            variant: "body2",
                            fontWeight: primaryWeight,
                        },
                        secondary: { variant: "caption" },
                    }}
                />
            </ListItemButton>
        </ListItem>
    );
}
